






















































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Pagination from "@/components/shared/Pagination.vue";
import { PaperlessDocumentDto } from "@/model/data.model";
import {
  IPagination,
  SearchParams,
  GetPaperlessResults
} from "@/model/component.model";
import { ShipmentService } from "@/services/ShipmentService";
import {
  alertDangerReason,
  displayPdf,
  downloadFileBase64
} from "@/services/Helpers";
import i18n from "@/lang/i18n";

@Component({
  components: {
    Pagination: Pagination
  }
})
export default class PaperlessManagementTableComponent extends Vue {
  @Prop({})
  mbeDocumentTypesId?: number;
  @Prop({ default: 900 })
  maxHeight?: number;
  @Prop({
    default: () => {
      return [];
    }
  })
  paperlessIds?: number[];
  @Prop({ default: false })
  sentPaperlessDocument: boolean;
  @Prop({ default: false }) edition: boolean;
  @Prop({}) courier?: number;
  paperlessDocuments: PaperlessDocumentDto[] = [];
  @Prop({ default: false })
  showPastPaperlessDocuments: boolean;
  selected: number[] = [];
  topScrollbarContentWidth = 0;
  allDocumentsSelected = false;
  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };
  searchParams: SearchParams = {
    search: "",
    orderField: "creationDate",
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };
  recentlyUploadedPaperlessDocumentIds: number[] = [];

  created() {
    if (
      (this.isEditShipment && this.disableEditPaperless) ||
      this.isShipmentsManagement
    ) {
      this.getDocumentsOfSelectedIds();
    }
  }

  getDocumentsOfSelectedIds() {
    ShipmentService.prototype
      .getPaperlessContentDocumentsByIds(this.paperlessIds, true, true)
      .then((res: any) => {
        this.paperlessDocuments = res;
      })
      .catch(err => {
        return alertDangerReason(err, this);
      });
  }

  openDocument(arg: any) {
    if (arg.content != null) {
      if (arg.contentFormatType === "PDF") {
        try {
          displayPdf(arg.content, arg.filename, this);
        } catch (e) {
          this.$alerts.danger(String(i18n.t("could_not_open_file")));
        }
      } else {
        try {
          downloadFileBase64(
            arg.content,
            arg.contentFormatType,
            arg.filename,
            this
          );
        } catch (e) {
          console.error(e);
          this.$alerts.danger(String(i18n.t("could_not_open_file")));
        }
      }
    } else {
      ShipmentService.prototype
        .getPaperlessContentDocumentByIdAndCourierId(arg.id, arg.courierId)
        .then((res: any) => {
          const fileContent = res.content;
          const fileName = res.filename;

          if (res.contentFormatType === "PDF") {
            try {
              displayPdf(fileContent, fileName, this);
            } catch (e) {
              this.$alerts.danger(String(i18n.t("could_not_open_file")));
            }
          } else {
            try {
              downloadFileBase64(
                fileContent,
                res.contentFormatType,
                fileName,
                this
              );
            } catch (e) {
              console.error(e);
              this.$alerts.danger(String(i18n.t("could_not_open_file")));
            }
          }
        })
        .catch(err => {
          return alertDangerReason(err, this);
        });
    }
  }

  setSelectedDocument() {
    if (this.paperlessIds.length > 0) {
      this.paperlessDocuments.map((item: PaperlessDocumentDto) => {
        if (this.paperlessIds.includes(item.id)) {
          item.selected = true;
        }
      });
      this.selected = this.paperlessIds;
    }
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }

  @Watch("showPastPaperlessDocuments")
  onShowPastPaperlessDocumentsChange() {
    this.search();
  }

  @Watch("courier")
  onCourierChange() {
    if (
      this.$route.name === "NewShipment" ||
      this.$route.name === "EditShipment"
    ) {
      this.search();
    }
  }

  @Watch("sentPaperlessDocument", { deep: true, immediate: true })
  async onSentPaperlessDocumentChange() {
    if (this.sentPaperlessDocument && this.paperlessIds.length > 0) {
      this.paperlessIds.forEach(async id => {
        await this.search(id);
      });
      this.setSelectedDocument();
    }
  }

  search(idToSelect?: number) {
    if (
      (this.isShipmentsManagement && this.disableEditPaperless) ||
      this.isShipmentsManagement
    ) {
      this.getDocumentsOfSelectedIds();
    } else {
      const docId = this.mbeDocumentTypesId ? this.mbeDocumentTypesId : null;

      if (idToSelect) {
        this.recentlyUploadedPaperlessDocumentIds.push(idToSelect);
      }

      ShipmentService.prototype
        .getPaperlessDocuments(
          docId,
          this.customerId,
          this.$store.getters.user.username,
          this.searchParams,
          this.$store.getters["customer/config"]
            .showShipmentsWithSameCustomerId,
          this.courier
        )
        .then((res: GetPaperlessResults) => {
          this.paperlessDocuments = [];

          res.content.forEach((item: PaperlessDocumentDto) => {
            const o: PaperlessDocumentDto = {
              ...(item as PaperlessDocumentDto)
            };
            o.selected =
              (idToSelect && o.id === idToSelect) ||
              this.paperlessIds.includes(o.id);

            if (this.showPastPaperlessDocuments) {
              // Show document regardless of the fact that it was just attached or not
              this.paperlessDocuments.push(o);
            } else if (
              this.recentlyUploadedPaperlessDocumentIds.length > 0 &&
              this.recentlyUploadedPaperlessDocumentIds.includes(o.id)
            ) {
              // Show document only if it was recently attached
              this.paperlessDocuments.push(o);
            }
          });
          this.pagination.totalElements = res.totalElements;

          this.searchParams.totalElements = res.totalElements;
          this.searchParams.totalPages = res.totalPages;
          this.searchParams.numberOfElements = res.numberOfElements;
          this.searchParams.page = res.number;
          this.searchParams.pageSize = res.size;

          if (idToSelect && !this.selected.includes(idToSelect)) {
            this.selected = [...this.paperlessIds, idToSelect];
          } else {
            this.selected = [...this.paperlessIds];
          }
          // Updating selected documents to match only currently shown documents
          const shownPaperlessDocumentIds = this.paperlessDocuments.map(
            (document: any) => document.id
          );
          this.selected = this.selected.filter((sel: number) =>
            shownPaperlessDocumentIds.includes(sel)
          );
          this.$emit("selected-changed", this.selected);

          this.$nextTick(() => {
            this.setTopScrollBarWidth();
          });
        })
        .catch(err => {
          this.$snotify.error(err.response.data.message);
        });
    }
  }

  selectItem(item: PaperlessDocumentDto, value: boolean) {
    item.selected = !item.selected;
    if (value) {
      this.selected.push(item.id);
    } else {
      this.selected.splice(this.selected.indexOf(item.id), 1);
    }
    this.$emit("selected-changed", this.selected);
  }

  selectAll(value: boolean) {
    this.allDocumentsSelected = value;
    this.selected = [];
    this.paperlessDocuments.forEach((document: PaperlessDocumentDto) => {
      document.selected = value;
      if (value) this.selected.push(document.id);
    });
    this.$emit("selected-changed", this.selected);
  }

  tableScrolling($event: any) {
    (this.$refs.topScrollbar as HTMLElement).scrollLeft =
      $event?.target?.scrollLeft || 0;
  }

  setTopScrollBarWidth() {
    this.topScrollbarContentWidth =
      (this.$refs.table as HTMLElement).clientWidth - 1;
  }

  selectOrderFieldAndDirection(orderField: string) {
    if (this.searchParams.orderField === orderField) {
      const isAsc = this.searchParams.orderDirection === "asc";
      this.searchParams.orderDirection = isAsc ? "desc" : "asc";
    } else {
      this.searchParams.orderField = orderField;
      this.searchParams.orderDirection = "desc";
    }

    this.search();
  }

  deletePaperlessDocuments() {
    ShipmentService.prototype
      .deletePaperlessDocumentByIds(this.selected)
      .then((res: any) => {
        this.$notify.success(String(i18n.t("delete_paperless_doc_success")));
      })
      .catch(err => {
        return alertDangerReason(err, this);
      })
      .finally(() => {
        if (this.mbeDocumentTypesId) {
          this.search();
        }
      });
  }

  deleteDocument(document: PaperlessDocumentDto) {
    ShipmentService.prototype
      .deletePaperlessDocumentByIds([document.id])
      .then((res: any) => {
        this.$notify.success(String(i18n.t("delete_paperless_doc_success")));
        this.paperlessIds.length > 0 &&
          this.$emit("documentDeleted", document.id);
      })
      .catch(err => {
        return alertDangerReason(err, this);
      })
      .finally(() => {
        this.search();
      });
  }

  topScrolling($event: any) {
    (this.$refs.tablecontainer as HTMLElement).scrollLeft =
      $event.target.scrollLeft;
  }

  get isShipmentsManagement() {
    return this.$route.name === "ShipmentsManagement";
  }

  get isEditShipment() {
    return this.$route.name === "EditShipment";
  }

  get disableEditPaperless() {
    return !(this.edition || this.$route.name === "PaperlessManagement");
  }

  get isNewShipment() {
    return this.$route.name === "NewShipment";
  }

  get isPaperlessManagement() {
    return this.$route.name === "PaperlessManagement";
  }

  get customerId() {
    return this.$store.getters["customer/info"].customerId;
  }
}
